'use client';

import { faBox } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

export function BlankIcon(): ReactNode {
	// TODO: Font Awesome doesn't have a blank icon, so we're using a box with hidden visibility. We should replace this with an actual blank icon if Font Awesome adds one in the future.
	return <FontAwesomeIcon icon={faBox} style={{ visibility: 'hidden' }} aria-hidden="true" />;
}
